import { combineReducers } from 'redux';

import { reducer as actorsReducer } from '@savgroup-front-common/core/domains/actors';
import { reducer as attachmentsReducer } from '@savgroup-front-common/core/domains/attachments';
import { reducer as carriersReducer } from '@savgroup-front-common/core/domains/carriers';
import { reducer as claimsReducer } from '@savgroup-front-common/core/domains/claims';
import { reducer as fileUploadReducer } from '@savgroup-front-common/core/domains/fileUpload';
import { reducer as i18nReducer } from '@savgroup-front-common/core/domains/i18n';
import routerReducer from '@savgroup-front-common/core/domains/router/reducer';
import { reducer as sagaRequestMetadataReducer } from '@savgroup-front-common/core/domains/sagaRequestMetadata';
import { reducer as sellerConfigurationReducer } from '@savgroup-front-common/core/domains/sellerConfiguration';
import { sellerReducer } from '@savgroup-front-common/core/domains/sellers';
import { sparePartSupplierReducer } from '@savgroup-front-common/core/domains/sparePartSupplier';
import { storeReducer } from '@savgroup-front-common/core/domains/store';
import { technicalInterventionsReducer } from '@savgroup-front-common/core/domains/technicalInterventions';

import { reducer as additionalInformationReducer } from '@/domains/additionalInformation';

import { reducer as accessReducer } from './access';
import businessReducer from './business/businessReducer';
import { reducer as controlClaimsReducer } from './claims';
import { repairerReducer as controlRepairerReducer } from './controlRepairer';
import { reducer as filesReducer } from './files';
import { reducer as marketplaceTicketsReducer } from './marketplaceTickets';
import { reducer as modelsReducer } from './models';
import { reducer as ordersReducer } from './orders';
import { reducer as ownerReducer } from './owner';
import { reducer as quoteReducer } from './quote';
import { reducer as refundsReducer } from './refunds';
import { repairerReducer } from './repairer';
import { reducer as sellersInfoReducer } from './sellersInfo';
import { sparePartRequestReducer } from './sparePartRequests';
import { sparePartsReducer } from './spareParts';
import { stocksReducer } from './stocks';
import { userManagementReducer } from './userManagement';
import { usersReducer } from './users';
import { reducer as workflowReducer } from './workflow';

const createRootReducer = () =>
  combineReducers({
    orders: ordersReducer,
    sparePartRequests: sparePartRequestReducer,
    users: usersReducer,
    actors: actorsReducer,
    claims: claimsReducer,
    i18n: i18nReducer,
    repairer: repairerReducer,
    controlRepairer: controlRepairerReducer,
    sagaRequestMetadata: sagaRequestMetadataReducer,
    sparePartSupplier: sparePartSupplierReducer,
    store: storeReducer,
    userManagement: userManagementReducer,
    spareParts: sparePartsReducer,
    access: accessReducer,
    additionalInformation: additionalInformationReducer,
    attachments: attachmentsReducer,
    business: businessReducer,
    carriers: carriersReducer,
    fileUpload: fileUploadReducer,
    files: filesReducer,
    marketplaceTickets: marketplaceTicketsReducer,
    models: modelsReducer,
    owner: ownerReducer,
    quote: quoteReducer,
    sellersInfo: sellersInfoReducer,
    refunds: refundsReducer,
    router: routerReducer,
    sellerConfiguration: sellerConfigurationReducer,
    sellers: sellerReducer,
    stocks: stocksReducer,
    list: technicalInterventionsReducer,
    workflow: workflowReducer,
    controlClaims: controlClaimsReducer,
  });

export default createRootReducer;
